import { render, staticRenderFns } from "./snakelist.vue?vue&type=template&id=648da34c&scoped=true&"
import script from "./snakelist.vue?vue&type=script&lang=js&"
export * from "./snakelist.vue?vue&type=script&lang=js&"
import style0 from "./snakelist.vue?vue&type=style&index=0&id=648da34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648da34c",
  null
  
)

export default component.exports